const apiRoot = '/api';
export default apiRoot;
